import { useState } from 'react';
import './App.css';

import Auth from './Auth';
import Home from './Home';
import { clearStorage, getToken, setToken } from './data/models/GlobalAdmin';
import { useNavigate } from 'react-router-dom';


function App() {
  const [accessToken,setAccessToken] = useState(getToken());
  const navigate = useNavigate();

  const setAndStoreToken=(token)=>{
    if(token==null){
      clearStorage();
      window.location.reload()
      
    }
    else{
      console.log('New Token',token)
      setToken(token);
      setAccessToken(token)
    }

  }
  const containerStyles = {
    overflow: 'auto',
    scrollbarWidth: 'none', /* Firefox */
    '-ms-overflow-style': 'none', /* Internet Explorer and Edge */
    '&::-webkit-scrollbar': {
      width: '0.5em',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'transparent',
    },
  };
  return (
    <div className='bg-image' style={containerStyles}>
      	{accessToken ==null?<Auth setAccessToken={setAndStoreToken}/>:<Home setAndStoreToken={setAndStoreToken}/>}
    </div>
  );
}

export default App;
